import { Button } from "@/components/ui/button";
import lottie from "lottie-web";
import { ArrowRight } from "lucide-react";
import { useEffect, useRef } from "react";
import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";

export function HeroSection() {
  const animationContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (animationContainer.current) {
      const anim = lottie.loadAnimation({
        container: animationContainer.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "/animation/processo-de-compra.json",
      });

      return () => anim.destroy();
    }
  }, []);

  return (
    <section className="py-8 md:py-24 bg-n-bg-green">
      <div className="container">
        <div className="grid md:grid-cols-2">
          <div className="text-left mb-4">
            <h1
              className="md:mb-8 mb-4 md:mt-16 mt-10 text-[40px] font-normal text-n-beige md:text-6xl lg:text-[62px]"
              style={{ fontFamily: "'Anton', sans-serif", lineHeight: "1.2em" }}
            >
              Sua plataforma digital de transporte de veículos
            </h1>
            <div className="hidden md:flex md:gap-6 gap-1 mb-5">
              <div className="flex gap-1 items-center border rounded-full border-n-text-beige py-1 px-3 h-[34px]">
                <img src="/icons/reclameaqui.png" alt="Reclame aqui" />
                <p className="text-n-text-beige font-medium text-xs">
                  Somos nota máxima no Reclame Aqui!
                </p>
              </div>
              <div className="flex gap-1 items-center border rounded-full border-n-text-beige py-1 px-3 h-[34px]">
                <img src="/icons/icoGG.png" alt="google" />
                <p className="text-n-text-beige font-medium text-xs flex items-center gap-1.5">
                  <FaStar className="text-n-text-beige w-3 h-3" /> 5 estrelas no
                  Google!
                </p>
              </div>
            </div>
            <p className="md:mb-8 mb-6 text-n-text-beige font-regular">
              Cotou, contratou, chegou. Tudo digital, sem ligação, sem
              enrolação. Seu carro de onde está para onde quiser, com preço
              fechado e agendamento em poucos passos.
            </p>

            <Link to="/fazer-cotacao">
              <Button className="">
                Agendar meu transporte <ArrowRight className="ml-2 " />
              </Button>
            </Link>
          </div>

          <div className="flex items-center justify-center mt-[60px] md:mt-0">
            <div
              ref={animationContainer}
              className="md:h-[600px] h-[400px] w-full max-w-[600px]"
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
}
